import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from "@/components/ui/chart";
import { Area, AreaChart, CartesianGrid, XAxis, YAxis } from "recharts";
import type { UserGrowthData } from "@/services/api";

const config: ChartConfig = {
  invited: { label: "邀请注册", color: "#10b981" },
  normal: { label: "普通注册", color: "#3b82f6" },
};

export function UserGrowthChart({ data }: { data: UserGrowthData[] }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>用户增长趋势</CardTitle>
        <CardDescription>每日新增用户（邀请注册 + 普通注册）</CardDescription>
      </CardHeader>
      <CardContent>
        {data.length > 0 ? (
          <ChartContainer config={config} className="h-[300px] w-full">
            <AreaChart data={data} stackOffset="none">
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} allowDecimals={false} />
              <ChartTooltip content={<ChartTooltipContent />} />
              <ChartLegend content={<ChartLegendContent />} />
              <Area
                type="monotone"
                dataKey="normal"
                stackId="1"
                stroke="var(--color-normal)"
                fill="var(--color-normal)"
                fillOpacity={0.5}
                name="普通注册"
              />
              <Area
                type="monotone"
                dataKey="invited"
                stackId="1"
                stroke="var(--color-invited)"
                fill="var(--color-invited)"
                fillOpacity={0.5}
                name="邀请注册"
              />
            </AreaChart>
          </ChartContainer>
        ) : (
          <div className="h-[300px] flex items-center justify-center text-muted-foreground">
            暂无数据
          </div>
        )}
      </CardContent>
    </Card>
  );
}
